module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/Accordion-dffc3bf9cb0ee09b5148dfb72a0f47e4.png";